// extracted by mini-css-extract-plugin
export default {"brandPromo":"DG-z","carousel":"EG-z"};